<template>
    <a-scene loading-screen="enabled:false">
 <a-entity  v-if="!ifVr" camera orbit-controls="target: 0 2.5 -5; initialPosition: 0 0 0; 
              maxDistance: 25;maxPolarAngle:180;
      
                    ">
                  </a-entity>
      <a-entity  v-if="ifVr" camera look-controls >
     
     <a-entity   raycaster="objects: .pauseObject"
  cursor="fuse: true;fuseTimeout: 2000"
            >
  </a-entity>
 </a-entity>
               



  <a-assets timeout="10000" @loaded="assetsLoaded">
<audio  v-if="!iosCheck" src="static/ambient.mp3"  loop id="ambient"></audio>

      <img v-if="vrcheck" id="pause" src="static/img/bigpause.svg">
        <img v-if="vrcheck" id="play" src="static/img/bigplay.svg">

<audio v-if="iosCheck" src="static/audio-long.mp3"  id="long-audio"></audio>
<audio v-if="!iosCheck" src="static/audio.mp3"  id="main-audio"></audio>

<audio v-if="!iosCheck" src="static/processed.mp3"   id="processed"></audio>
<audio v-if="!iosCheck" src="static/whales.mp3"  loop id="whales"></audio>
<audio v-if="!iosCheck" src="static/paper.mp3"  loop id="paper" ></audio>
<audio v-if="!iosCheck" src="static/cello.mp3"  loop id="cello" ></audio>

<img v-for="bluefish in allTheFishes" :key="bluefish.blueId" :src="bluefish.blueSrc" :id="bluefish.blueId">
<img v-for="paperfish in allTheFishes" :key="paperfish.paperId" :src="paperfish.paperSrc" :id="paperfish.paperId">

<a-mixin id="basicFish"  rotation="0 0 0" scale="0.8 0.8 0.8"  material="fog: true" ></a-mixin>

    
    </a-assets>

 <a-sky color="#010431"></a-sky>
 <a-entity id="target"  position="0 2.5 -5"></a-entity>
  <fish-component v-for="fish in allTheFishes" :key="fish.key" :fish="fish" />

<a-circle v-if="ifVr" rotation="-90 0 0" position="0 -25 0"  radius="10" src="#pause" handle-events class="pauseObject"
    animation__click="startEvents:click; property:scale; dur: 150;from:0.1 0.1 0.1;to: 1 1 1;">

      </a-circle>

  </a-scene>
  
</template>
<script>

    import FishComponent from './FishComponent.vue'
    import allTheFishes from '../fishes'

    export default {
        name: 'story',
        data() {
            return {
            allTheFishes,
            ifVr: this.vrcheck
            }
        },
        props: {
            vrcheck: Boolean,
            iosCheck: Boolean
        },
        methods: {
            assetsLoaded: function () {
            this.$emit('assetsLoaded')
            },
           vrPause: function() {
      this.$emit('vrPause')
    }
        },
        mounted: function() { 

            if (this.ifVr) {
            var vrPauseButton = document.querySelector('a-circle')
            vrPauseButton.addEventListener('click', this.vrPause)
            }
            
        },
        components: {
            FishComponent

        },
  destroyed: function() {
  }

    }
    
     
</script>
<style>
    .a-enter-vr {

        display: none;
    }
</style>